import React from 'react';
import { useTranslation } from 'localization';
import ScopeCoinAtom from '../../atoms/marketplace/ScopeCoinAtom';
import './PublisherChipMolecule.scss';

export interface PublisherChipMoleculeProps {
  publisherSlug: string;
  displayName: string;
  glyph?: string;
  hue?: number;
  isOfficial?: boolean;
  /** 'light' renders a white pill with blue border; 'dark' for use on coloured backgrounds */
  tone?: 'light' | 'dark';
  onClick?: (slug: string) => void;
  className?: string;
}

const PublisherChipMolecule: React.FC<PublisherChipMoleculeProps> = ({
  publisherSlug,
  displayName,
  glyph,
  hue,
  isOfficial = false,
  tone = 'light',
  onClick,
  className = '',
}) => {
  const { t } = useTranslation();

  const classes = [
    'marketplace-publisher-chip',
    `marketplace-publisher-chip--${tone}`,
    onClick ? 'marketplace-publisher-chip--clickable' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const handleClick = () => onClick?.(publisherSlug);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.(publisherSlug);
    }
  };

  return (
    <span
      className={classes}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick ? handleClick : undefined}
      onKeyDown={onClick ? handleKeyDown : undefined}
    >
      <ScopeCoinAtom
        scope="center"
        glyph={glyph}
        channelName={displayName}
        glyphKind="letter"
        hue={hue}
        size="sm"
        className="marketplace-publisher-chip__coin"
      />
      <span className="marketplace-publisher-chip__by">
        {t('marketplace.publishers.by_prefix')}
      </span>
      <span className="marketplace-publisher-chip__name">{displayName}</span>
      {isOfficial && (
        <i
          className="pi pi-verified marketplace-publisher-chip__official"
          aria-hidden="true"
        />
      )}
    </span>
  );
};

PublisherChipMolecule.displayName = 'PublisherChipMolecule';

export default PublisherChipMolecule;
